module.exports = __webpack_public_path__ + "images/emoji/smiley.361e57996884356dad35.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/smiley.png
// module id = azc5
// module chunks = 24